import { IAppState } from '../../../AppModulesWrapper';

export const selectIsSubagentNotEnoughMoney = (state: IAppState): boolean => {
  return state.servicePickerWidget.publishInfo.isSubagentNotEnoughMoney;
};
